import React, {useState} from 'react';
import AppContext from '../app';

export default function AppContextProvider({children}) {
  const [mainHeading, setMainHeading] = useState('');
  const [contentDirection, setContentDirection] = useState('');
  const [showProfile, toggleProfile] = useState(false);

  return (
    <AppContext.Provider value={{mainHeading, setMainHeading, showProfile, toggleProfile, contentDirection, setContentDirection}}>
      {children}
    </AppContext.Provider>
  );
}
